module.exports = __webpack_public_path__ + "static/media/watchAdsIcon.b382c0e1.png";